import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import blueUnderline from '../OrgImages/blueunderline.svg';
import stepIcon from '../OrgImages/Stepiconbase.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

const BENEFITS = [
  {
    key: 'expert',
    text: (
      <>
        Expert support from professionals at EY, SAP, F5, <br />
        and more
      </>
    ),
  },
  { key: 'events', text: 'Live events to learn, grow, and connect with peers' },
  { key: 'funding', text: 'Early access to funding opportunities' },
  {
    key: 'curated',
    text: (
      <>
        Curated connections to a global network of <br />
        impact partners
      </>
    ),
  },
];

export const OrgWebsiteShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section
      ref={sectionRef}
      className='relative h-full w-full overflow-hidden bg-gradient-to-t from-secondary-brand-50/85 from-[23%] to-secondary-brand-25/85 to-[95%]'
    >
      <div className='flex h-full w-full justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle} className='flex flex-col px-8 pt-10'>
            <h1 className='m-0 text-display-xl font-semibold text-gray-700 tracking-[-1.2px]'>
              High quality <br />
              support,{' '}
              <span className='relative inline-block'>
                without
                <img src={blueUnderline} alt='' className='absolute left-0 top-full w-full' />
              </span>{' '}
              the <br />
              price tag
            </h1>
            <ul className='mt-12 flex flex-col gap-6'>
              {BENEFITS.map((benefit) => (
                <li key={benefit.key} className='flex items-start gap-3'>
                  <img src={stepIcon} alt='' className='h-6 w-6 flex-shrink-0' />
                  <span className='text-lg font-semibold text-gray-700'>{benefit.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
